import React from 'react'
import {
  Control,
  FieldValues,
  Path,
  PathValue,
  RegisterOptions,
  useController,
} from 'react-hook-form'
import { TextArea, TextAreaProps } from '@manychat/manyui'

type HookFormTextAreaProps<Values extends FieldValues = FieldValues> = TextAreaProps & {
  control?: Control<Values>
  name: Path<Values>
  rules?: RegisterOptions<Values>
  defaultValue?: PathValue<Values, Path<Values>>
}

export const HookFormTextArea = <Values extends FieldValues>({
  name: fieldName,
  rules,
  defaultValue,
  control,
  ...passProps
}: HookFormTextAreaProps<Values>) => {
  const {
    field: { name, value, onChange },
    fieldState: { error },
  } = useController({ name: fieldName, rules, defaultValue, control })

  return (
    <TextArea
      {...passProps}
      value={value}
      onChange={onChange}
      name={name}
      errorText={error?.message}
      invalid={Boolean(error?.message)}
    />
  )
}
